import { observer } from 'mobx-react';
import clsx from 'clsx';
import { ComponentProps } from 'react';
import ModalBody from './ModalBody';
import ModalCloseButton from './ModalCloseButton';
import ModalContainer from './ModalContainer';
import ModalFocusTrap from './ModalFocusTrap';
import ModalShade from './ModalShade';
import ModalTitle from './ModalTitle';
import { CloseAction } from './UseOpenable';
interface ModalContentProps {
  close: CloseAction;
  title: ComponentProps<typeof ModalTitle>['title'];
  children: React.ReactNode;
  dimensions?: {
    maxHeight?: string;
  };
  placement?: {
    zIndex?: string;
  };
}

function ModalContent({ title, close, children, dimensions, placement }: ModalContentProps) {
  return (
    <ModalFocusTrap>
      <ModalContainer
        onEscPressed={close}
        className={clsx(
          'flex fixed',
          'top-0 left-0 right-0 bottom-0',
          'justify-center align-center',
          placement?.zIndex ? placement.zIndex : '',
        )}
      >
        <ModalBody
          className={clsx(
            dimensions?.maxHeight ? dimensions.maxHeight : 'max-h-[600px]',
            placement?.zIndex ? placement.zIndex : 'z-10',
            'mt-[18vh]',
            'px-[1.825rem] py-[1.825rem]',
            'w-[60vw] max-w-[600px]',
            'overflow-auto',
            'bg-white',
            'rounded',
          )}
        >
          <ModalCloseButton close={close} label="Close" />
          <ModalTitle
            title={title}
            className={clsx('mt-6 mb-4', 'px-2', 'font-semibold text-2xl')}
          />
          <div data-test-modal-content={true} className="px-2">
            {children}
          </div>
        </ModalBody>
        <ModalShade
          close={close}
          className={clsx('absolute', 'top-0 right-0 left-0 bottom-0', 'opacity-75 bg-[#1f2229]')}
        />
      </ModalContainer>
    </ModalFocusTrap>
  );
}

export default observer(ModalContent);
